export const formatDate = (isoDate: string): string => {
    const date = new Date(isoDate);
    return (
        date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
        '   ' +
        date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false })
    );
};
